<template>

<com-segment class="generic" :segment="subsection" :section="section" v-on:close="$emit('close')">

	<div class="generic-segment" :data-name="segment" v-for="segment in segments" :key="segment">

		<div class="generic-segment-icon"></div>
		<div class="generic-segment-title">{{ section[subsection][segment].title }}</div>
		<div class="generic-segment-text" v-html="prepareText(section[subsection][segment].text)"></div>

	</div>

	<com-links :links="section[subsection].links" />

</com-segment>

</template>

<script>

import comSegment from './Segment'
import comLinks from './../common/Links'

export default {

	props: ['section', 'subsection', 'segments'],

	components: {
		'com-segment': comSegment,
		'com-links': comLinks
	},

	methods: {

		prepareText: function(text) {

			text = text.replace(/{{bullet}}/g, '<span class="bullet"></span>')
			text = text.replace(/\[url=([^\]]+)\](.*?)\[\/url\]/g, '<a href="$1" target="_blank" class="text-link">$2</a>')

			return text

		}

	}
	
}

</script>

<style scoped>

.generic-segment:first-child {
	margin-top: 80px;
}

.generic-segment {
	padding-bottom: 64px;
	padding-left: 200px;
	padding-right: 200px;
	min-height: 120px;
	margin-bottom: 32px;
}

.generic-segment-icon {
	width: 170px;
	height: 120px;
	position: absolute;
	left: 0px;
	top: 0px;
	background-position: 100% 0px;
	background-repeat: no-repeat;
}

.generic-segment[data-name="calcium"] .generic-segment-icon { background-image: url(~@/assets/aid/improve/supplements/icon.calcium.svg); }
.generic-segment[data-name="vitamins"] .generic-segment-icon { background-image: url(~@/assets/aid/improve/supplements/icon.vitamins.svg); top: -16px; }
.generic-segment[data-name="sunlight"] .generic-segment-icon { background-image: url(~@/assets/aid/improve/supplements/icon.sunlight.svg); }
.generic-segment[data-name="smoking"] .generic-segment-icon { background-image: url(~@/assets/aid/improve/habits/icon.smoking.svg); }
.generic-segment[data-name="alcohol"] .generic-segment-icon { background-image: url(~@/assets/aid/improve/habits/icon.alcohol.svg); }
.generic-segment[data-name="steady"] .generic-segment-icon { background-image: url(~@/assets/aid/improve/activity/icon.steady.svg); }
.generic-segment[data-name="strong"] .generic-segment-icon { background-image: url(~@/assets/aid/improve/activity/icon.strong.svg); }
.generic-segment[data-name="straight"] .generic-segment-icon { background-image: url(~@/assets/aid/improve/activity/icon.straight.svg); }
.generic-segment[data-name="falls"] .generic-segment-icon { background-image: url(~@/assets/aid/improve/activity/icon.falls.svg); }
.generic-segment[data-name="outdoors"] .generic-segment-icon { background-image: url(~@/assets/aid/improve/activity/icon.outdoors.svg); }

.generic-segment-title {
	color: #343434;
	font-size: 24px;
	font-weight: 600;
	margin-bottom: 16px;
}

.generic-segment-text {
	color: #343434;
	font-size: 18px;
	line-height: 22px;
	font-weight: 400;
}

.generic-segment-text >>> .bullet {
	width: 22px;
	height: 22px;
	display: inline-block;
	vertical-align: middle;
	background-size: contain;
	background-position: 0% 0px;
	background-repeat: no-repeat;
	background-size: 16px 16px;
	background-image: url(~@/assets/aid/common/bullet.png);
}

.is-patient .generic-segment-text >>> .bullet {
	background-image: url(~@/assets/aid/common/link.png);
}

.generic-segment-text >>> .text-link {
	color: #343434;
	font-weight: 600;
	text-decoration: underline;
	text-decoration-color: var(--aid-color);
	text-underline-offset: 3px;
	text-decoration-thickness: 2px;
	cursor: pointer;
	transition: color 300ms ease-in-out;
}

.generic-segment-text >>> .text-link:hover {
	color: var(--aid-color);
}

</style>
